import { dateFilter } from '../utils/filters'
import { cloneDeep } from '../utils/utils'
import queryMixin from './query'

const FILTERS_NAMES_MAP = {
  partner: 'parnterName',
  tournament: 'tournamentName',
  team: 'teamName'
}

const getExcludeFilters = (options = { withDate: false }) => {
  const EXCLUDE_FILTERS = [
    'parnterName', 'tournamentName', 'teamName'
  ]

  if (options.withDate) {
    return [
      'date_start', 
      'date_end',
      ...EXCLUDE_FILTERS
    ]
  }

  return EXCLUDE_FILTERS
}

export default {
  data () {
    return {
      isLoading: true,
      unwatchers: {},
      filtersOptions: {},
      filters: {}
    }
  },
  mixins: [queryMixin],
  watch: {
    '$route.name' () {
      this.filters = {}
    }
  },
  methods: {
    handleFiltersEvent (event) {
      Object.keys(event).forEach(key => {
        this.$set(this.filters, key, event[key].id || event[key])

        if (key === 'date' && event[key].length > 1) {
          this.toggleQuery([
            {
              name: 'date_start',
              value: dateFilter(event[key][0], 'MM-DD-YY')
            },
            {
              name: 'date_end',
              value: dateFilter(event[key][1], 'MM-DD-YY')
            }
          ])

          return
        }

        if (typeof event[key] === 'object' && event[key] && FILTERS_NAMES_MAP[key]) {
          this.toggleQuery([
            {
              name: key,
              value: event[key].id
            },
            {
              name: FILTERS_NAMES_MAP[key],
              value: event[key].name
            }
          ])

          return
        }

        this.toggleQuery({
          name: key,
          value: event[key].id || event[key]
        })
      })
    },
    async getFiltersOptions (filters) {
      this.isLoading = true

      filters.forEach(async (filter) => {
        const { name, getter } = filter

        if (typeof getter !== 'function') {
          console.info('Getter is not a function: ', name)

          return
        }

        const response = await getter()

        if (!response || !response.data) {
          console.info('No data: ', name)

          return
        }

        this.$set(this.filtersOptions, name, { list: response.data, count: response.count })
      })

      this.isLoading = false
    },
    clearFilter (key) {
      const filters = cloneDeep(this.filters)
 
      delete filters[key]

      if (key === 'date') {
        this.toggleQuery([
          { name: 'date_start' },
          { name: 'date_end' }
        ])
      } else {
        this.toggleQuery({
          name: key
        })

        if (FILTERS_NAMES_MAP[key]) {
          this.toggleQuery({
            name: FILTERS_NAMES_MAP[key]
          })
        }
      }

      this.filters = filters
    },
    clearFilters () {
      Object.keys(this.filters).forEach(key => {
        if (getExcludeFilters().includes(key)) {
          this.toggleQuery({
            name: key
          })

          return
        }

        this.clearFilter(key)
      })
    },
    createFilterWatcher (key, handler) {
      if (this.unwatchers[key]) {
        return
      }

      this.unwatchers[key] = this.$watch(key, handler)
    }
  },
  created () {
    Object.keys(this.$route.query).forEach(item => {
      if (getExcludeFilters({ withDate: true }).includes(item)) {
        return
      }

      this.$set(this.filters, item, Number(this.$route.query[item]))
    }) 

    if (this.$route.query.date_start && this.$route.query.date_end) {
      this.$set(this.filters, 'date', [this.$route.query.date_start, this.$route.query.date_end])
    }
  }
}